module.exports = __webpack_public_path__ + "img/vehicle.69cd031d.svg";